<template>
  <v-bottom-sheet
    v-model="expensesBottomSheet"
    inset
    scrollable
    hide-overlay
    no-click-animation
    persistent
    internal-activator
  >
    <template v-slot:activator="{ attrs }">
      <v-btn
        :color="common.color.expenses" block small dark
        v-bind="attrs"
        @click="openBottomSheet">
        <v-icon dark small left>
          mdi-plus
        </v-icon>
        仮払経費
      </v-btn>
    </template>
    <v-card v-if="isShow" class="expenses-bottom-sheet" >
      <v-card-title class="expenses-bottom-sheet__title">
        <span class="expenses-bottom-sheet__title__date">
          <span class="expenses-bottom-sheet__title__date__num" >{{common.select.year}}</span>年
          <span class="expenses-bottom-sheet__title__date__num" >{{common.select.month}}</span>月
          <span class="expenses-bottom-sheet__title__date__num" >{{common.select.day}}</span>日
          (<span class="ml-1 mr-1">{{common.week[common.select.dayOfWeek]}}</span>)
        </span>
        <v-spacer/>
        <v-icon @click="closeBottomSheet">
          mdi-chevron-down
        </v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="expenses-bottom-sheet__content">
        <v-list dense>
          <v-subheader>履歴から追加</v-subheader>
          <v-list-item-group
            class="expenses-bottom-sheet__list"
            :color="common.color.primary">          
            <v-list-item
              v-for="(expense, key) in data.history.expenses"
              :key="key">
              <v-list-item-content 
                @click="insertExpense(expense)">
                <v-list-item-subtitle >
                  {{expense.accountTitle}}
                </v-list-item-subtitle>
                <v-list-item-title class="expenses-bottom-sheet__list-item__title">
                  <span>
                    {{expense.discription}}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle >
                  {{expense.amount.toLocaleString()}}<span class="ml-1">円</span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon small @click="removeHistoryItem(expense)">
                  mdi-close
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-5">
        <v-spacer/>
        <v-btn :color="common.color.expenses" dark block
          @click="openExpensesDialog">
          <v-icon dark small left>
            mdi-plus
          </v-icon>
          新たに仮払経費を設定する
        </v-btn>
        <v-spacer/>
      </v-card-actions>        
    </v-card>
  </v-bottom-sheet>
</template>

<script>

  export default {
    props: ["common", "data", "dialog"],
    data: () => ({
      expensesBottomSheet: false,
      isShow: true,
    }),
    methods: {
      openBottomSheet() {
        this.common.eventBus.$emit('App.overflow.add')
        this.expensesBottomSheet = true
      },
      closeBottomSheet() {
        this.common.eventBus.$emit('App.overflow.remove')
        this.expensesBottomSheet = false
      },
      openExpensesDialog() {
        this.dialog.year = this.common.select.year
        this.dialog.month = this.common.select.month
        this.dialog.day = this.common.select.day
        this.dialog.expense = {}
        this.common.eventBus.$emit('ExpensesDialog.open')
      },
      removeHistoryItem(expense) {
        this.deleteExpensesHistory(expense.id).then(() => {
          this.common.eventBus.$emit('App.reload')
        })
        .catch(err => {
          this.errorProcess(err)
        })
      },
      insertExpense(expense) {
        let temp = { ...expense }
        temp.id = undefined
        temp.date = this.common.select.date
        this.setExpense(temp)
        .then(() => {
          let day = this.common.select.day
          this.common.select.day = undefined
          this.common.select.day = day
          this.common.eventBus.$emit('App.reload')
        })
        .catch(err => {
          this.errorProcess(err)
        })
      },
      reload() {
        this.isShow = false
        this.isShow = true
      },
    },
    created() {
      this.common.eventBus.$on('ExpensesBottomSheet.reload', this.reload)
      this.common.eventBus.$on('ExpensesBottomSheet.close', this.closeBottomSheet)
    }
  }
</script>

<style scoped>
  .expenses-bottom-sheet{
    color: var(--textColor-default);
  }
  .expenses-bottom-sheet__title {
    padding:5px 20px !important;
  }
  .expenses-bottom-sheet__title__date {
    font-size: small;
  }
  .expenses-bottom-sheet__title__date__num {
    font-size: large;
    font-weight: normal;
  }
  .expenses-bottom-sheet__list {
    display: flex;
    flex-direction: column-reverse;
  }
  .expenses-bottom-sheet__content {
    max-height: 200px;
    min-height: 100px;
  }
  .expenses-bottom-sheet__list-item__title {
    color: var(--textColor-default);
    font-weight: normal;
  }

</style>
